import * as generalApi from '../../../general/api';

export function getCoverage(params) {
  return generalApi.getDeviceCoverage({ cloudType: 'rdc', ...params });
}

export function getCoverageCSV(params) {
  return generalApi.getDeviceCoverageCSV({ cloudType: 'rdc', ...params });
}
